export default __webpack_public_path__ + "static/media/trial-ends-toolbox.51029316.svg";